// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".outer[data-v-6d3f34a6]{display:grid;grid-template-columns:240px calc(100vw - 240px)}@media print{.outer[data-v-6d3f34a6]{grid-template-columns:1fr}}.navigation[data-v-6d3f34a6]{overflow:visible}.main[data-v-6d3f34a6]{height:100vh;overflow-x:hidden;overflow-y:auto;padding-bottom:110px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
